// This action is meant to ensure that "/api/users/me" request is executed at least once
// so one can easily call this action without worrying about duplicate requests as the
// implementaiton uses caching
import { createAction } from '@lingoda/core';

export default createAction('auth/REQUEST_MY_DATA');
